<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modal.title"
    @on-confirm="save"
    @on-cancel="hide"
    :okText="$t('Save')"
    :closeText="$t('Close')"
    maxWidth="60%"
  >
   <v-row justify="center" align="center" v-if="loading">
      <div class="text-center">
        <v-progress-circular
          class="my-4"
          :size="50"
          width="5"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-row>
    <v-row v-if="conditionItems.length == 0 && !loading" justify="center" align="center">
      <v-col cols="1">
        <v-btn
          color="primary"
          prepend-icon="mdi-plus"
          outlined
          @click="addAction()"
        >
          {{ $t("Add") }}
        </v-btn>
      </v-col>
    </v-row>
    <div v-for="item in conditionItems" :key="item.uuid" v-if="!loading">
      <SearchCriteriaCondition
        :ref="`searchCriteriaConditionKey${item.uuid}`"
        :fieldList="fieldList"
        :conditionItem="item"
        :origin="3"
        @on-condition-item-add="addAction"
        @on-condition-item-remove="removeAction"
      />
    </div>
  </base-modal>
</template>
<script>
import StateTransitionAction from '@/ecm/models/workflow/StateTransitionAction';
import ConditionItem from '@/ecm/models/search/ConditionItem';
import FieldType from '@/ecm/variables/FieldType';
import SearchService from '@/services/SearchService';
import SearchCriteriaCondition from '@/components/search/SearchCriteriaCondition.vue';
import ContentTypeService from '@/services/ContentTypeService';
import SearchUtils from '@/components/search/utilsSearch/UtilsSearch.js';
import Utils from '@/ecm/common/Utils.js';

export default {
    name: 'ActionsModal',
    components: {
        SearchCriteriaCondition
    },
    props: {
        contentTypeIDs: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            modal: {
                title: this.$t('Actions'),
                key: 'actionModalKey'
            },
            open: false,
            loading: false,
            conditionItems: [],
            fieldList: []
        };
    },
    methods: {
        async getFields() {
            await SearchService.getAdvSearchFields(this.contentTypeIDs).then(
                data => {
                    this.fieldList = data;
                }
            );
        },
        async edit(actions) {
            this.show();
            this.loading = true;
            this.conditionItems = [];
            var self = this;
            await this.getFields();
            actions.forEach(item => {
                var fieldType = self.fieldList.find(x => x.Code === item.defFieldCode).Type;
                var conditionStr = `${item.defFieldCode}|s01|${item.value}|${FieldType[fieldType]}`;
                var conditionItem = new ConditionItem(conditionStr);
                self.setDisplayValue(conditionItem);
                conditionItem.isParameterizable = item.isParameterizable;
                self.conditionItems.push(conditionItem);
            });
            this.loading = false;
        },
        setDisplayValue(conditionItem) {
            const context = this;
            if (!conditionItem.fieldDisplayValue) {
                conditionItem.fieldDisplayValue = SearchUtils.GetDisplayValueFromFieldValue(
                    conditionItem.fieldValue, context
                );
            } else {
                conditionItem.fieldDisplayValue = SearchUtils.GetDisplayValueFromFieldValue(
                    conditionItem.fieldDisplayValue, context
                );
            }
        },
        async save() {
            var actions = this.conditionItems.filter(f => f.fieldCode).map(x => {
                var action = new StateTransitionAction();
                action.defFieldCode = x.fieldCode;
                action.value = x.fieldValue;
                action.isParameterizable = x.isParameterizable;
                return action;
            });
            const fieldCodes = actions.map(action => action.defFieldCode);
            const duplicates = fieldCodes.filter((code, index) => fieldCodes.indexOf(code) !== index);
            if (duplicates.length > 0) {
                const uniqueDuplicates = [...new Set(duplicates)];
                Utils.toast.error(this.$t('DuplicateFieldsErrorOnActions').replaceAll('{0}', uniqueDuplicates.join(', ')));
                return;
            }
            var contentTypeFields = await ContentTypeService.getFields(this.contentTypeIDs);
            var uniqueFields = [
                ...new Set(
                    contentTypeFields
                        .filter(
                            (f) => f.IsUnique && actions.some((a) => a.defFieldCode == f.Code)
                        )
                        .map((f) => f.Name)
                ),
            ];
            if (uniqueFields.length > 0) {
                if (uniqueFields.length > 0) {
                    var confirmMessage = this.$t(
                        'UniqueFieldsAutomaticActionsWarning'
                    ).replaceAll('{0}', uniqueFields.join());

                    var res = await this.$confirm(confirmMessage, {
                        title: this.$t('Confirm'),
                        icon: 'mdi-alert',
                        color: 'warning',
                        buttonTrueText: this.$t('Save'),
                        buttonFalseText: this.$t('Cancel'),
                    });

                    if (res != 1) {
                        return;
                    }
                }
            }
            this.$emit('on-saved', actions);
            this.hide();
        },
        removeAction(item) {
            this.conditionItems = this.conditionItems.filter(
                f => f.uuid != item.uuid
            );
        },
        addAction() {
            this.conditionItems.push(new ConditionItem());
        },
        show() {
            this.open = true;
        },
        hide() {
            this.open = false;
        }
    }
};
</script>
